const projectData = [
    {
        id: 0,
        pThumbnail: 'https://i.postimg.cc/4yCfztxn/guitar-shop.png',
        title: 'Gitár Shop',
        text: 'Egy létező gitárgyártó cég weboldalának másolata.',
        builtInIcons: [
            {
                id: 0,
                className: 'fab fa-react'
            }
        ],
        gitHubLink: 'https://github.com/fbalazs930/guitar-shop',
        website: 'https://guitar-shop.pages.dev/',
        images: [
            {
                id: 0,
                src: 'https://i.postimg.cc/mZSWbyvd/image.png'
            },
            {
                id: 1,
                src: 'https://i.postimg.cc/SRgPcDqk/image.png'
            },
            {
                id: 2,
                src: 'https://i.postimg.cc/qM7SpVXR/image.png'
            },
            {
                id: 3,
                src: 'https://i.postimg.cc/x1w4GkrJ/image.png'
            },
            {
                id: 4,
                src: 'https://i.postimg.cc/gjtMxjq0/image.png'
            },
            {
                id: 5,
                src: 'https://i.postimg.cc/850WW63x/image.png'
            },
            {
                id: 6,
                src: 'https://i.postimg.cc/kXtNQT7s/image.png'
            }
        ]
    },
    {
        id: 1,
        pThumbnail: 'https://i.postimg.cc/pXqCrBTW/messenger.png',
        title: 'Messenger App',
        text: 'Facebook Messengerhez hasonló üzenetküldő App. Firebase adatbázissal készült, amely lehetővé teszi az üzenetek megőrzését.',
        builtInIcons: [
            {
                id: 0,
                className: 'fab fa-react'
            }
        ],
        gitHubLink: 'https://github.com/fbalazs930/messenger-app',
        website: 'https://messenger-app.pages.dev/',
        images: [
            {
                id: 0,
                src: 'https://i.postimg.cc/8Ph3j6bc/image.png'
            },
            {
                id: 1,
                src: 'https://i.postimg.cc/nVqTkt9w/image.png'
            }
        ]
    },
    {
        id: 2,
        pThumbnail: 'https://i.postimg.cc/kgg9NbQX/weather.png',
        title: 'Időjárás',
        text: 'A weboldal megmutajta bármelyik város jelenlegi időjárásának információit egy ingyenes API (OpenWeatherMap) használatával.',
        builtInIcons: [
            {
                id: 0,
                className: 'fab fa-react'
            }
        ],
        gitHubLink: 'https://github.com/fbalazs930/idojaras-api-react',
        website: 'https://idojaras-api-react.pages.dev/',
        images: [
            {
                id: 0,
                src: 'https://i.postimg.cc/d1Gs30NY/image.png'
            },
            {
                id: 1,
                src: 'https://i.postimg.cc/NG4tzSWp/image.png'
            }
        ]
    }
];

export default projectData;